import request from '@/libs/request'

// 订单列表
export function orderList (data) {
  return request({
    url: `order/list`,
    method: 'get',
    params: data
  })
}

// 订单详情
export function orderInfo (data) {
  return request({
    url: `order/info`,
    method: 'get',
    params: data
  })
}

// 订单发货信息
export function deliveryInfo (data) {
  return request({
    url: `order/getDelivery`,
    method: 'get',
    params: data
  })
}

// 更改订单发货状态
export function changeFh (data) {
  return request({
    url: `order/changeStatus`,
    method: 'post',
    data: data
  })
}
// 提交回复
export function replay (data) {
  return request({
    url: `order/addReplay`,
    method: 'post',
    data: data
  })
}



// 订单发货
export function orderDeliveryApi (data) {
  return request({
    url: `order/delivery`,
    method: 'post',
    data: data
  })
}

// 查询订单物流信息
export function getLogisticsApi (id) {
  return request({
    url: `order/getLogistics`,
    method: 'get',
    params: {
      order_id: id
    }
  })
}
